import { useCallback, useEffect, useRef } from 'react';

export type ListScrollOffsetProps = {
  scrollOffset: number;
};

export const useHandleScroll = (
  listData: unknown[],
  itemSize: number,
  loadMore?: () => void,
  hasMore?: boolean,
  loadingMore?: boolean
) => {
  const scrollTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const handleScroll = useCallback(
    (props: ListScrollOffsetProps) => {
      if (!loadMore || !hasMore || loadingMore) return;

      const { scrollOffset } = props;
      const scrollThreshold = 200;

      const totalHeight = listData.length * itemSize;
      const visibleHeight = 400;
      const currentPosition = scrollOffset + visibleHeight;

      if (currentPosition >= totalHeight - scrollThreshold) {
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }

        scrollTimeoutRef.current = setTimeout((): void => {
          loadMore();
        }, 100);
      }
    },
    [loadMore, hasMore, loadingMore, listData.length, itemSize]
  );

  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  return { handleScroll, scrollTimeoutRef };
};
